import { Dispatch, SetStateAction, createContext } from 'react';
import { QAndASides } from 'router/subrouters/DataRoom/models/QAndA';
import { SessionType } from 'models/Message';
import { User } from 'models/User';
import utils from 'utils';

type MessagingContextProps = {
  interlocutor: User;
  loadingSession: boolean;
  currentSession: SessionType;
  contactOpen: boolean;
  contactsOpen: boolean;
  listingId?: string;
  dealRoomId?: string;
  listingEnquiryId?: string;
  sessionId: string;
  ownerId?: string;
  userSide?: QAndASides;
  dataRoomId?: string;
  dataRoomName?: string;
  setContactsOpen: Dispatch<SetStateAction<boolean>>;
  setContactOpen: Dispatch<SetStateAction<boolean>>;
  setCurrentSession: Dispatch<SetStateAction<SessionType>>;
};

export default createContext<MessagingContextProps>({
  interlocutor: null,
  loadingSession: false,
  currentSession: null,
  contactOpen: true,
  contactsOpen: true,
  listingId: null,
  dealRoomId: null,
  listingEnquiryId: null,
  sessionId: null,
  ownerId: null,
  userSide: null,
  dataRoomId: null,
  dataRoomName: null,
  setContactOpen: utils.noop,
  setContactsOpen: utils.noop,
  setCurrentSession: utils.noop,
});
